"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeInput = void 0;
var react_1 = __importStar(require("react"));
var MaskField_1 = require("../../MaskField");
var DateRangeInput = function (_a) {
    var valueField = _a.valueField, format = _a.format, props = __rest(_a, ["valueField", "format"]);
    var mask = (0, react_1.useMemo)(function () { return getMask(format); }, [format]);
    return (react_1.default.createElement(MaskField_1.VMaskField, __assign({ value: valueField, inline: true, noLabel: true, fill: true, margin: '0', guide: false, placeholder: format, mask: mask }, props, { autoComplete: 'off' })));
};
exports.DateRangeInput = DateRangeInput;
var getMask = function (format) {
    var charArray = "".concat(format).split('');
    return charArray === null || charArray === void 0 ? void 0 : charArray.map(function (char) {
        switch (char.toLowerCase()) {
            case 'd':
            case 'm':
            case 'y':
            case 'k':
            case 'h': {
                return /[0-9]/;
            }
            case 'a': {
                return [/[a,p]/, /m/];
            }
            default: {
                return char;
            }
        }
    }).flat();
};
